export const featureReducer = (state = {
  static: {},
  featureList: [],
  fetching: false,
  fetched: false,
  error: null
}, action) => {
  
  switch (action.type) {
    case 'HANDLE_CREATE_FEATURE': {
      state = {
        ...state,
        static: action.payload
      };
      break;
    }

    case 'HANDLE_UPDATE_FEATURE': {
      state = {
        ...state,
        static: action.payload
      };
      break;
    }

    case 'GET_FEATURES': {
      state = {
        ...state,
        fetching: true,
        fetched: false
      };
      break;
    }

    case 'GET_FEATURES_FULFILLED': {
      state = {
        ...state,
        fetching: false,
        fetched: true,
        featureList: action.payload
      };
      break;
    }

    case 'GET_FEATURES_REJECTED': {
      state = {
        ...state,
        fetching: false,
        fetched: false,
        error: action.payload
      };
      break;
    }

    default: {
      break;
    }
  }

  return state;
};



export const putFeatureReducer = (state = {
  static: {},
  putting: false,
  didPut: false,
  error: null
}, action) => {
  
  switch (action.type) {
    case 'PUT_FEATURE': {
      state = {
        ...state,
        putting: true,
        didPut: false
      };
      break;
    }

    case 'PUT_FEATURE_FULFILLED': {
      state = {
        ...state,
        putting: false,
        didPut: true,
        static: action.payload
      };
      break;
    }

    case 'PUT_FEATURE_REJECTED': {
      state = {
        ...state,
        putting: false,
        didPut: false,
        error: action.payload
      };
      break;
    }

    case 'PUT_FEATURE_RESET': {
      state = {
        putting: false,
        didPut: false
      };

      break;
    }

    default: {
      break;
    }
  }

  return state;
};


export const postFeatureReducer = (state = {
  feature: [],
  posting: false,
  posted: false,
  error: null
}, action) => {
  
  switch (action.type) {
    case 'POST_FEATURE': {
      state = {
        ...state,
        posting: true,
        posted: false
      };
      break;
    }

    case 'POST_FEATURE_FULFILLED': {
      state = {
        ...state,
        posting: false,
        posted: true,
        feature: action.payload
      };
      break;
    }

    case 'POST_FEATURE_REJECTED': {
      state = {
        ...state,
        posting: false,
        posted: false,
        error: action.payload
      };
      break;
    }

    case 'POST_FEATURE_RESET': {
      state = {
        posting: false,
        posted: false
      };

      break;
    }


    default: {
      break;
    }
  }

  return state;
};


export default featureReducer;